export default "__VITE_ASSET__E$vQElUs__"